import type { Ref } from 'vue';
import { computed, nextTick, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { createGlobalState } from '@vueuse/core';
import type { HistoryRowData, NavMenuItem } from '../types';
import { getHistoryList } from '../infrastructure/api-functions';
import { useCachedOpened } from './use-cached-opended';
import { create } from '@eureka/utils/deferred';
import { getHistoryRouterData } from '../infrastructure/utils/history-router';
import _ from 'lodash';

export const useNavBarState = createGlobalState(
    () => {
        const { load, save } = useCachedOpened();

        const opened = ref(load());

        const shouldSave = ref(true);

        const loading = ref(true);

        const route = useRoute();

        const listDeferred = create<NavMenuItem[]>();

        const historyList: Ref<NavMenuItem[]> = ref([]);

        const currentDetailId = computed(() => {
            return route.params?.seek_id || route.params?.board_id || route.params?.projectId || route.params?.fmea_id || route.query?.board_id || route.params?.taskId || route.params?.id || route.params?.agent_job_id || route.params?.lsAgentId
        })

        const currentRouteFlag = computed(() => {
            return route.path + currentDetailId.value;
        })

        const routeName = computed(() => {
            return route.name;
        })

        function updateNavStatus(value: boolean, save = true) {
            opened.value = value;
            shouldSave.value = save;
            // 确保在下一个 DOM 更新周期中重新启用保存
            nextTick(() => {
                shouldSave.value = true;
            });
        }

        function updateHistory(list: NavMenuItem[]) {
            historyList.value = list;
        }

        function queryList() {
            loading.value = true;
            getHistoryList().then((res) => {
                const data = _.flatMap(res.history_maps, 'data') as HistoryRowData[]
                historyList.value = data.map(item => {
                    const { router, module } = getHistoryRouterData(item.source, item.id);
                    return {
                        type: item.source,
                        id: item.id,
                        title: item.message,
                        link: item.link,
                        router,
                        module,
                        active: item.id === currentDetailId.value,
                    }
                })
                listDeferred.resolve(historyList.value)
                loading.value = false;
            });
        }

        watch(currentDetailId, () => {
            historyList.value = historyList.value.map(item => ({ ...item, active: item.id === currentDetailId.value }))
        })

        return {
            opened,
            loading,
            historyList,
            currentDetailId,
            routeName,
            currentRouteFlag,
            updateNavStatus,
            queryList,
            updateHistory,
            save,
            shouldSave,
        }
    }
)
